module.exports = __webpack_public_path__ + "static/sec3-a05f6dc7013a1c7d232cb0afa1547c96.png";